import { Link } from 'react-router-dom';
import { getNewUpdates } from '@/mocks/comics';

export default function NewUpdates() {
  const newComics = getNewUpdates(8);

  return (
    <section className="py-14 md:py-20 bg-background-50" aria-labelledby="updates-title">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2
              id="updates-title"
              className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2"
            >
              最新更新
            </h2>
            <p className="text-sm text-foreground-600">刚刚更新的热门章节，立即追更</p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            更多更新
            <i className="ri-arrow-right-line" style={{ width: '14px', height: '14px' }}></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {newComics.map((comic) => {
            const latestChapter = comic.chapters[comic.chapters.length - 1];
            return (
              <Link
                key={comic.slug}
                to={`/comic/${comic.slug}`}
                className="group flex gap-4 p-4 bg-background-100 rounded-xl border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
              >
                <div className="w-20 h-28 md:w-24 md:h-32 flex-shrink-0 rounded-lg overflow-hidden">
                  <img
                    src={comic.coverImage}
                    alt={comic.title}
                    title={`${comic.title} - 最新更新`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="flex-1 min-w-0 flex flex-col justify-between">
                  <div>
                    <h3 className="font-heading text-sm md:text-base text-foreground-900 group-hover:text-primary-500 transition-colors truncate mb-1">
                      {comic.title}
                    </h3>
                    <p className="text-xs text-foreground-500 truncate">{comic.author} · {comic.status}</p>
                  </div>
                  <div>
                    {latestChapter && (
                      <div className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-accent-100 text-accent-700 rounded-full text-xs font-label">
                        <i className="ri-file-list-3-line" style={{ width: '12px', height: '12px' }}></i>
                        {latestChapter.title}
                      </div>
                    )}
                    <p className="text-xs text-foreground-400 mt-2">
                      更新于 {comic.updatedAt}
                    </p>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}